import {SwiperListBaseModel} from "./swiper-list-base.model";

export abstract class ApiListBaseModel extends SwiperListBaseModel {
    protected get _isAISorted(): boolean {
        return false;
    }

    protected _applyGameGroupFiltering(gameTypes: number[]): number[] {
        const allowedGameGroups = this.listConfiguration.allowedGameGroups;
        if (!allowedGameGroups || allowedGameGroups.length === 0) {
            return gameTypes;
        }

        return gameTypes.filter(gameType => {
            return allowedGameGroups.includes(this.services.games.gamesMap[gameType]?.gameGroupId);
        });
    }
}